import ConsumersService from '../../../../services/consumers.service';
import ClassesService from '../../../../services/classes.service';

export async function getConsumers(store) {
    const consumers = await ConsumersService().getConsumers();
    store.setState({ ConsumerConfig: { ...store.state.ConsumerConfig, consumers } })
}

export async function getClassGroups(store) {
    const classGroups = await ClassesService().getClassGroups();
    store.setState({ ConsumerConfig: { ...store.state.ConsumerConfig, classGroups } })
}

export async function saveConsumerConfiguration(store, configs) {
    const { selectedCourses, allSelected, filters } = store.state.CourseList;
    if (allSelected)
        await ConsumersService().bulkEditAllConsumerConfiguration({ ...filters, ...configs });
    else
        await ConsumersService().bulkEditConsumerConfiguration({ courses: selectedCourses, ...configs });
}

